import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b2cbce2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "chevron_left", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "pagination__numbers" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "of", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "chevron_right", -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "pagination__button pagination__button--prev",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
    }, _hoisted_3),
    _createElementVNode("span", _hoisted_4, [
      _createTextVNode(_toDisplayString(_ctx.minPageCount) + "-" + _toDisplayString(_ctx.maxPageCount) + " ", 1),
      _hoisted_5,
      _createTextVNode(" " + _toDisplayString(_ctx.listCount), 1)
    ]),
    _createElementVNode("button", {
      class: "pagination__button pagination__button--next",
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
    }, _hoisted_7),
    _createVNode(_component_Dropdown, {
      modelValue: _ctx.paginOptions.pageSize,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paginOptions.pageSize) = $event)),
      options: _ctx.paginDropdownOptions,
      optionLabel: "name",
      optionValue: "value",
      class: "pagination__dropdown",
      onChange: _ctx.sendChange
    }, null, 8, ["modelValue", "options", "onChange"])
  ]))
}